import {
  ACCOUNTS_ROUTE,
  COPY_TRADING_MY_PROVIDER_PORTFOLIO_ROUTE,
  COPY_TRADING_MY_SUBSCRIPTIONS_ROUTE,
  COPY_TRADING_ROUTE,
  HOME_ROUTE,
  INTRODUCING_BROKER_ACCOUNT_COMMISSION_ROUTE,
  INTRODUCING_BROKER_CLIENT_COMMISSION_ROUTE,
  INTRODUCING_BROKER_COMMISSION_SETTINGS_ROUTE,
  INTRODUCING_BROKER_DASHBOARD_ROUTE,
  INTRODUCING_BROKER_IB_COMMISSIONS_ROUTE,
  INTRODUCING_BROKER_LINKS_ROUTE,
  INTRODUCING_BROKER_PERFORMANCE_DASHBOARD_ROUTE,
  INTRODUCING_BROKER_ROUTE,
  KYC_ROUTE,
  LEGAL_DOCUMENTS_URL,
  NEWS_ROUTE,
  PAYMENTS_ROUTE,
  PROFILE_ROUTE,
  SETTINGS_ROUTE,
  TRADE_ROUTE,
  TRANSACTION_ROUTE,
} from "_constants";
import { MdAccountTree, MdOutlineDashboard, MdSettings } from "react-icons/md";
import { TbFileBarcode, TbGraphFilled, TbHomeFilled } from "react-icons/tb";
import { AiOutlineFileSearch } from "react-icons/ai";
import { PiFilesBold, PiUserListFill } from "react-icons/pi";
import { IoIosWallet } from "react-icons/io";
import { BiSolidCopy, BiSolidFaceMask } from "react-icons/bi";
import { FaCircleUser } from "react-icons/fa6";
import { ImUserTie } from "react-icons/im";
import { GiNewspaper, GiShadowFollower } from "react-icons/gi";
import { LuLink, LuServerCrash, LuSettings2, LuSparkles } from "react-icons/lu";
import { GrCreativeCommons } from "react-icons/gr";

export const routesConfig = [
  {
    id: "home",
    title: "Home",
    messageId: "sidebar.verify-identity",
    icon: <TbHomeFilled size={22} />,
    path: HOME_ROUTE,
    level: 1,
    isMobileMenuRoute: true,
  },
  {
    id: "verify-identity",
    title: "Verify Identity",
    messageId: "sidebar.verify-identity",
    icon: <BiSolidFaceMask size={22} />,
    path: KYC_ROUTE,
    level: 1,
  },
  {
    id: "my-accounts",
    title: "My Accounts",
    mobileTitle: "Accounts",
    messageId: "sidebar.my-accounts",
    icon: <MdAccountTree size={22} />,
    path: ACCOUNTS_ROUTE,
    level: 1,
    isMobileMenuRoute: true,
  },
  {
    id: "payments",
    title: "Payments",
    messageId: "sidebar.payments",
    icon: <IoIosWallet size={22} />,
    path: PAYMENTS_ROUTE,
    level: 1,
  },
  {
    id: "transactions",
    title: "Transactions",
    messageId: "sidebar.transactions",
    icon: <AiOutlineFileSearch size={22} />,
    path: TRANSACTION_ROUTE,
    level: 1,
  },
  {
    id: "trade",
    title: "Trade",
    messageId: "sidebar.trade",
    icon: <TbGraphFilled size={22} />,
    path: TRADE_ROUTE,
    level: 1,
    isMobileMenuRoute: true,
  },
  {
    id: "copy-trading",
    title: "Copy Trading",
    messageId: "sidebar.copy-trading",
    icon: <BiSolidCopy size={22} />,
    path: COPY_TRADING_ROUTE,
    level: 1,
    isMobileMenuRoute: false,
    type: "collapse",
    children: [
      {
        id: "copy-trading-my-provider-portfolio",
        title: "My Provider Portfolio",
        messageId: "sidebar.copy-trading-my-provider-portfolio",
        icon: <PiUserListFill size={20} />,
        path: COPY_TRADING_MY_PROVIDER_PORTFOLIO_ROUTE,
      },
        {
        id: "copy-trading-my-subscriptions",
        title: "My Subscriptions",
        messageId: "sidebar.copy-trading-my-subscriptions",
        icon: <GiShadowFollower size={20} />,
        path: COPY_TRADING_MY_SUBSCRIPTIONS_ROUTE,
      },
    ],
  },
  {
    id: "introducing-broker",
    title: "Introducing Broker",
    messageId: "sidebar.introducing-broker",
    icon: <ImUserTie size={22} />,
    path: INTRODUCING_BROKER_ROUTE,
    level: 1,
    isMobileMenuRoute: false,
    type: "collapse",
    children: [
      {
        id: "introducing-broker-dashboard",
        title: "Dashboard",
        messageId: "sidebar.introducing-broker-dashboard",
        icon: <MdOutlineDashboard size={20} />,
        path: INTRODUCING_BROKER_DASHBOARD_ROUTE,
      },
      {
        id: "introducing-broker-performance-dashboard",
        title: "Performance Dashboard",
        messageId: "sidebar.introducing-broker-performance-dashboard",
        icon: <LuSparkles size={20} />,
        path: INTRODUCING_BROKER_PERFORMANCE_DASHBOARD_ROUTE,
      },
      {
        id: "introducing-broker-ib-commissions",
        title: "IB Commissions",
        messageId: "sidebar.introducing-broker-ib-commissions",
        icon: <GrCreativeCommons size={20} />,
        path: INTRODUCING_BROKER_IB_COMMISSIONS_ROUTE,
      },
      {
        id: "introducing-broker-commission-setting",
        title: "Commission Settings",
        messageId: "sidebar.introducing-broker-commission-setting",
        icon: <LuSettings2 size={20} />,
        path: INTRODUCING_BROKER_COMMISSION_SETTINGS_ROUTE,
      },
      {
        id: "introducing-broker-links",
        title: "Links",
        messageId: "sidebar.introducing-broker-links",
        icon: <LuLink size={20} />,
        path: INTRODUCING_BROKER_LINKS_ROUTE,
      },
      {
        id: "introducing-broker-account-commission",
        title: "Account Commission",
        messageId: "sidebar.introducing-account-commission",
        icon: <TbFileBarcode size={20} />,
        path: INTRODUCING_BROKER_ACCOUNT_COMMISSION_ROUTE,
      },
      {
        id: "introducing-broker-client-commission",
        title: "Client Commission",
        messageId: "sidebar.introducing-client-commission",
        icon: <LuServerCrash size={20} />,
        path: INTRODUCING_BROKER_CLIENT_COMMISSION_ROUTE,
      },
    ],
  },
  {
    id: "news",
    title: "News",
    messageId: "sidebar.news",
    icon: <GiNewspaper size={22} />,
    path: NEWS_ROUTE,
    level: 1,
    isMobileMenuRoute: true,
  },
  {
    id: "profile",
    title: "Profile",
    messageId: "sidebar.profile",
    icon: <FaCircleUser size={22} />,
    path: PROFILE_ROUTE,
    level: 1,
    isMobileMenuRoute: true,
  },
  {
    id: "settings",
    title: "Settings",
    messageId: "sidebar.settings",
    icon: <MdSettings size={22} />,
    path: SETTINGS_ROUTE,
    level: 1,
  },
  {
    id: "legal-documents",
    title: "Legal Documents",
    messageId: "sidebar.legal-documents",
    path: LEGAL_DOCUMENTS_URL,
    level: 2,
    icon: <PiFilesBold size={22} />,
  },
];
